import React from "react";
import experienceicon from "../images/Components/experienceicon.png";
import registrationicon from "../images/Components/registrationicon.png";
import advocateicon from "../images/Components/advocateicon.png";
import clienticon from "../images/Components/clienticon.png";
import milestonewave from "../images/Components/milestonewave.png";
import milestonecurve from "../images/Components/milestonecurve.png";
import tar from "../images/Components/tar.png";

function Milestone() {
  return (
    <>
      {/* Milestones greater than SM */}
      <div
        className="max-w-[1193px] bg-[#FFFCE6] mx-auto my-20 pt-[81px] pb-[108px] sm:px-[160px] hidden sm:block sm:relative "
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <div className="">
          <h1 className="font-[merriweather] text-center text-[#363537] font-bold leading-[43.5px] tracking-[0.42px] text-[36px]">
            Milestones
          </h1>

          <div className="sm:flex flex-row  md:flex-wrap md:gap-y-12 lg:gap-y-0 lg:flex-nowrap justify-center items-center mt-20 gap-x-[130px]">
            <div
              className="flex flex-col items-center"
              data-aos="fade-left"
              data-aos-duration="1000"
            >
              <img
                className="w-[75px] h-[92px]"
                src={experienceicon}
                alt="experience_icon"
              />

              <h2 className="font-[montserrat] text-[50px] text-[#17212B] leading-[42px] font-semibold mt-12">
                15+
              </h2>
              <p className="font-[Lato] text-[#575857] text-[22px] leading-[28px] text-center w-[142px] mt-7 font-bold">
                years experience
              </p>
            </div>

            <div
              className="flex flex-col items-center"
              data-aos="fade-left"
              data-aos-duration="1000"
            >
              <img
                className="w-[92px] h-[113px]"
                src={registrationicon}
                alt="registration_icon"
              />

              <h2 className="font-[montserrat] text-[50px] text-[#17212B] leading-[42px] font-semibold mt-12">
                1000+
              </h2>
              <p className="font-[Lato] text-[#575857] text-[22px] leading-[28px] text-center w-[142px] mt-7 font-bold">
                registrations completed
              </p>
            </div>

            <div
              className="flex flex-col items-center"
              data-aos="fade-left"
              data-aos-duration="1000"
            >
              <img
                className="w-[96px] h-[105px]"
                src={advocateicon}
                alt="experience_icon"
              />

              <h2 className="font-[montserrat] text-[50px] text-[#17212B] leading-[42px] font-semibold mt-12">
                5+
              </h2>
              <p className="font-[Lato] text-[#575857] text-[22px] leading-[28px] text-center w-[142px] mt-7 font-bold">
                advocates
              </p>
            </div>

            <div
              className="flex flex-col items-center"
              data-aos="fade-left"
              data-aos-duration="1000"
            >
              <img
                className="w-[130px] h-[98px]"
                src={clienticon}
                alt="experience_icon"
              />

              <h2 className="font-[montserrat] text-[50px] text-[#17212B] leading-[42px] font-semibold mt-12">
                750+
              </h2>
              <p className="font-[Lato] text-[#575857] text-[22px] leading-[28px] text-center w-[142px] mt-7 font-bold">
                clients
              </p>
            </div>
          </div>

          <img
            src={milestonewave}
            alt="milestone_wave"
            className=" hidden sm:block sm:absolute w-[218px] h-[201px]  right-0 top-[0px]"
          />
          <img
            src={tar}
            alt="milestone_star"
            className=" hidden sm:block sm:absolute w-[23px] h-[23px]  right-12 top-[50px]"
          />
          <img
            src={tar}
            alt="milestone_star"
            className=" hidden sm:block sm:absolute w-[23px] h-[23px]  left-56 top-[80px]"
          />
          <img
            src={tar}
            alt="milestone_star"
            className=" hidden sm:block sm:absolute w-[23px] h-[23px]  right-[330px] bottom-9"
          />
          <img
            src={milestonecurve}
            alt="milestone_curve"
            className=" hidden sm:block sm:absolute w-[108px] h-[128px]  left-0 bottom-0"
          />
        </div>
      </div>

      {/* Milestone lesser than SM */}
      <div className="bg-[#FFFCE6] mx-auto my-20 sm:hidden relative pt-[81px] pb-[108px]">
        <h1 className="font-[merriweather] text-center text-[#363537] font-bold leading-[43.5px] tracking-[0.42px] text-[36px]">
          Milestones
        </h1>

        <div className="flex flex-row justify-center items-center mt-20 gap-x-7">
          <div className="flex flex-col items-center">
            <img
              className="w-[45px] h-[62px]"
              src={experienceicon}
              alt="experience_icon"
            />

            <h2 className="font-[montserrat] text-[24px] sm:text-[45px] text-[#17212B] leading-[42px] font-bold mt-12">
              15+
            </h2>
            <p className="font-[Lato] text-[#575857] text-[20px] sm:text-[22px] leading-[28px] text-center w-[142px] sm:mt-7">
              Years Experience
            </p>
          </div>

          <div className="flex flex-col items-center">
            <img
              className="w-[65px] h-[83px]"
              src={registrationicon}
              alt="registration_icon"
            />

            <h2 className="font-[montserrat] text-[24px] sm:text-[45px] text-[#17212B] leading-[42px] font-bold mt-12">
              1000+
            </h2>
            <p className="font-[Lato] text-[#575857] text-[18px] sm:text-[22px] leading-[28px] text-center w-[142px] sm:mt-7">
              Registrations Completed
            </p>
          </div>
        </div>

        <div className="flex flex-row justify-center items-center mt-20 gap-x-7">
          <div className="flex flex-col items-center">
            <img
              className="w-[76px] h-[85px]"
              src={advocateicon}
              alt="experience_icon"
            />

            <h2 className="font-[montserrat] text-[24px] text-[#17212B] leading-[42px] font-bold mt-12">
              5+
            </h2>
            <p className="font-[Lato] text-[#575857] text-[18px] leading-[28px] text-center w-[142px]">
              Advocates
            </p>
          </div>

          <div className="flex flex-col items-center">
            <img
              className="w-[90px] h-[68px]"
              src={clienticon}
              alt="experience_icon"
            />

            <h2 className="font-[montserrat] text-[24px] text-[#17212B] leading-[42px] font-bold mt-12">
              750+
            </h2>
            <p className="font-[Lato] text-[#575857] text-[18px] leading-[28px] text-center w-[142px]">
              Clients
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Milestone;
